var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlertTagLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "alert-tag",
    xmlns: "http://www.w3.org/2000/svg",
    width: 282.4,
    height: 67.331,
    viewBox: "0 0 282.4 67.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "flag-inside",
    d: "M7.428,0,23.669,27.838,0,41.5Z",
    transform: "translate(0 46.579) rotate(-60)",
    fill: "#842521"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "flag-outside",
    d: "M278.257,40.316H0V0H278.722l-9.48,20.245,9.014,20.07h0Z",
    transform: "translate(3.678 0)",
    fill: "#cc3832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertTagLong);
export default __webpack_public_path__ + "static/media/icon-alert-tag-long.67e14ad9.svg";
export { ForwardRef as ReactComponent };